import {ubcLogger} from '@baidu/ubc-report-sdk';
import weirwoodJson from '@/../public/weirwood.json';

import {
    getUrlParameterByName,
} from '@/utils/url.js';

// 初始化
const urlSource = getUrlParameterByName('source');
ubcLogger.set({
    serverId: 16247,
    testMode: location.host !== 'yige.baidu.com',
    source: urlSource ? urlSource : '', // 来源source如果没有传空
    queryParams: {
        appname: 'yige',
    },
});

// 设备from / 页面page / 事件类型type / 事件名value / 扩展信息ext 版本version
function trackSendEvent(from, page, type, value, ext = {}) {
    const extData = {
        ...ext,
        version: weirwoodJson.buildid,
    };

    ubcLogger.send({
        from: from,
        page: page,
        type: type,
        value: value,
        ext: extData,
    });
}

// 获取page对应名字
function trackGetPageName(name) {
    // let path = RegExp(/groundPage/).exec(window.location.href);
    const newName = {
        'index': 'home',
        'space': 'space',
        'fileAdmin': 'fileAdmin',
        'fileAdminCreation': 'fileAdmin_creation',
        'favor': 'fileAdmin_favor',
        'collection': 'fileAdmin_collection',
        'folder': 'fileAdmin_folder',
        'groundPage': 'ground_page',
        'public': 'fileAdmin_public',
        'recommend': 'fileAdmin_recommend',
        'search': 'search',
        'points': 'points',
        'personal': 'personal',
        'agreement': 'personal_agreement',
        'cooperation': 'personal_cooperation',
        'disclaimer': 'personal_disclaimer',
        'aboutus': 'personal_aboutus',
        'information': 'personal_information',
        'order': 'personal_order_points',
        'news': 'personal_news',
        'guide': 'personal_guide',
        'feedback': 'personal_feedback',
        'energyPainterPlan': 'energy_painter_plan',
        'specialGround': 'special_ground',
        'creation': 'creation',
        'trainingCreation': 'lab_training_creation',
        'trainingManagement': 'lab_training',
        'trainingVerification': 'lab_training_verification',
        'trainingModelOutput': 'lab_training_output',
        'special': 'special',
    };
    return newName[name] ? newName[name] : name;
}

function useTrack(from = 'pc') {
    function trackEvent(page, type, value, ext = {}) {
        trackSendEvent(from, page, type, value, ext);
    }

    return {
        trackEvent,
        trackGetPageName,
    };
}

export default useTrack;